/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SleepPeriod } from './SleepPeriod';
import {
    SleepPeriodFromJSON,
    SleepPeriodFromJSONTyped,
    SleepPeriodToJSON,
    SleepPeriodToJSONTyped,
} from './SleepPeriod';
import type { ScheduledBlock } from './ScheduledBlock';
import {
    ScheduledBlockFromJSON,
    ScheduledBlockFromJSONTyped,
    ScheduledBlockToJSON,
    ScheduledBlockToJSONTyped,
} from './ScheduledBlock';

/**
 * 
 * @export
 * @interface SleepScheduleResponse
 */
export interface SleepScheduleResponse {
    /**
     * 
     * @type {Array<SleepPeriod>}
     * @memberof SleepScheduleResponse
     */
    sleepPeriods: Array<SleepPeriod>;
    /**
     * 
     * @type {Array<ScheduledBlock>}
     * @memberof SleepScheduleResponse
     */
    blocks: Array<ScheduledBlock>;
    /**
     * 
     * @type {string}
     * @memberof SleepScheduleResponse
     */
    timezone: string;
    /**
     * 
     * @type {number}
     * @memberof SleepScheduleResponse
     */
    totalSleepSeconds: number;
}

/**
 * Check if a given object implements the SleepScheduleResponse interface.
 */
export function instanceOfSleepScheduleResponse(value: object): value is SleepScheduleResponse {
    if (!('sleepPeriods' in value) || value['sleepPeriods'] === undefined) return false;
    if (!('blocks' in value) || value['blocks'] === undefined) return false;
    if (!('timezone' in value) || value['timezone'] === undefined) return false;
    if (!('totalSleepSeconds' in value) || value['totalSleepSeconds'] === undefined) return false;
    return true;
}

export function SleepScheduleResponseFromJSON(json: any): SleepScheduleResponse {
    return SleepScheduleResponseFromJSONTyped(json, false);
}

export function SleepScheduleResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SleepScheduleResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'sleepPeriods': ((json['sleep_periods'] as Array<any>).map(SleepPeriodFromJSON)),
        'blocks': ((json['blocks'] as Array<any>).map(ScheduledBlockFromJSON)),
        'timezone': json['timezone'],
        'totalSleepSeconds': json['total_sleep_seconds'],
    };
}

export function SleepScheduleResponseToJSON(json: any): SleepScheduleResponse {
    return SleepScheduleResponseToJSONTyped(json, false);
}

export function SleepScheduleResponseToJSONTyped(value?: SleepScheduleResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sleep_periods': ((value['sleepPeriods'] as Array<any>).map(SleepPeriodToJSON)),
        'blocks': ((value['blocks'] as Array<any>).map(ScheduledBlockToJSON)),
        'timezone': value['timezone'],
        'total_sleep_seconds': value['totalSleepSeconds'],
    };
}

